import { Map } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import {
  defaultLang,
  getCurrentMessages,
  getCurrentLang,
  setIntl,
} from 'lib/intl'

export const CHANGE_LANG = 'locale/CHANGE_LANG'

export const changeLang = ActionHelper.createActionObj(CHANGE_LANG)

const initialState = () =>
  Map({
    defaultLang,
    lang: getCurrentLang(),
    messages: getCurrentMessages(),
  })

export default handleActions(
  {
    [CHANGE_LANG]: (state, { payload: lang }) => {
      setIntl(lang)

      return state
        .set('lang', getCurrentLang())
        .set('messages', getCurrentMessages())
    },
  },
  initialState(),
)
